import React, { useState, useEffect } from 'react';
import { Breakpoint, useCurrentBreakpointName } from 'react-socks';

const CurrentSubscriptionDisplay = (props) => {
    let breakpoint = useCurrentBreakpointName();

    const numberDisplay = (input) => {
        if (input === -1) {
            return "Unlimited";
        }
        return input;
    }

    return (
        <div className={`plan-info-wrapper ${breakpoint}`}>
            <div className="plan-info">
                <div className="plan-overview">
                    {props.isEditingPlan !== undefined && props.isEditingPlan ? (
                        <div className="plan-state editing">
                            Plan change
                        </div>
                    ) : (
                        <div className="plan-state">
                            Current plan
                        </div>
                    )}
                    <div className="plan-name">
                        {props.planLabel} {props.planPriceLabel}
                    </div>
                    <div className="plan-renewal nunito-dlvr">
                        {props.renewalBlock !== undefined && props.renewalBlock ? (
                            props.renewalBlock
                        ) : null}
                    </div>
                </div>
                <div className="special-messages">
                    {props.annualIncentive !== undefined && props.annualIncentive ? (
                        props.annualIncentive
                    ) : null}
                </div>
            </div>
            {props.addOnElement !== undefined && props.addOnElement ? (
                props.addOnElement
            ) : null}
            <div className={`plan-detail ${breakpoint}`}>
                <div className="resource-column">
                    <div className="resource-usage outputs">
                        <div className="resource-label nunito-dlvr">{numberDisplay(props.nextLimits.outputs)} Social Profiles:</div>
                        <div className="in-use-label nunito-dlvr">{props.currentLimits.outputsInUse} in use</div>
                    </div>
                    <div className="resource-usage inputs">
                        <div className="resource-label nunito-dlvr">{numberDisplay(props.nextLimits.inputs)} Feeds and Sites:</div>
                        <div className="in-use-label nunito-dlvr"><span className="in-use-label">{props.currentLimits.inputsInUse} in use</span></div>
                    </div>
                </div>
                <div className="resource-column">
                    <div className="resource-usage posts">
                        <div className="resource-label nunito-dlvr">Posts / mo:</div>
                        <div className="in-use-label nunito-dlvr">{props.postLimit ? props.postLimit : "Unlimited"}</div>
                    </div>
                    <div className="resource-usage xposts">
                        <div className="resource-label nunito-dlvr">Extra X Posts / mo:</div>
                        <div className="in-use-label nunito-dlvr" onClick={props.editXeets}>{props.xtraXeets} <span className="edit-xeets"><i className="icon ion-edit"></i></span></div>
                    </div>
                </div>
            </div>
            <div className="show-detail-wrapper">
                {props.activeCouponBlock !== undefined && props.activeCouponBlock ?
                (
                    <div>
                        {props.activeCouponBlock}
                    </div>
                ) :
                (
                    <div></div>
                )}
            </div>
        </div>
    )
};

export default CurrentSubscriptionDisplay;
